module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-8-2268eacf63d1ba0a4775883fa9b599dd.webp";